import {
  SET_ORDER_DETAIL,
  SET_POOL_GRID_DATA,
  GET_POOL_GRID_DATA,
  GET_PURCHASE_TYPE_DROPDOWN,
  SET_PURCHASE_TYPE_DROPDOWN,
  SET_REGISTERED_DROPDOWN,
  GET_REGISTERED_DROPDOWN,
  GET_ORDER_TYPE_DROPDOWN,
  SET_ORDER_TYPE_DROPDOWN,
  GET_CLIENT_CODE_DROPDOWN,
  SET_CLIENT_CODE_DROPDOWN,
  GET_REASON_CODE_DROPDOWN,
  SET_REASON_CODE_DROPDOWN,
  GET_ASSIGNTO_DROPDOWN,
  SET_ASSIGNTO_DROPDOWN,
  SET_CAPEX_DROPDOWN,
  GET_CAPEX_DROPDOWN,
  SET_VENDOR_DETAILS,
  GET_VENDOR_DETAILS,
  SET_PURACHSE_ORDER_STEPPER_DATA,
  SET_ERROR,
  SET_PURACHSE_ORDER_STEPPER_INFO,
  SET_CHANGE_LOGS,
  GET_CHANGE_LOGS,
  UPDATE_FLEET_STATUS_ORDER,
  GET_FLEET_ORDER_DETAIL,
  SET_FLEET_ORDER_DETAIL,
  UPDATE_REASON_CODE,
  GET_PO_EQ_CLASS_CODE_DROPDOWN,
  SET_PO_EQ_CLASS_CODE_DROPDOWN
} from "./types";

const setOrderDetail = (value: any) => {
  return {
    type: SET_ORDER_DETAIL,
    value,
  };
};

const getFleetOrderDetail = (orderId: any) => {
  return {
    type: GET_FLEET_ORDER_DETAIL,
    orderId,
  };
};

const setFleetOrderDetail = (value: any) => {
  return {
    type: SET_FLEET_ORDER_DETAIL,
    value,
  };
};

const getPoolGridData = (subTypeId: any) => {
  return {
    type: GET_POOL_GRID_DATA,
    subTypeId
  };
};

const setPoolGridData = (value: any) => {
  return {
    type: SET_POOL_GRID_DATA,
    payload: value,
  };
};
const getPurchaseTypeDropdown = () => {
  return {
    type: GET_PURCHASE_TYPE_DROPDOWN,
  };
};

const setPurchaseTypeDropdown = (value: any) => {
  return {
    type: SET_PURCHASE_TYPE_DROPDOWN,
    payload: value,
  };
};
const getRegisteredDropdown = () => {
  return {
    type: GET_REGISTERED_DROPDOWN,
  };
};

const setRegisteredDropdown = (value: any) => {
  return {
    type: SET_REGISTERED_DROPDOWN,
    payload: value,
  };
};
const getOrderTypeDropdown = () => {
  return {
    type: GET_ORDER_TYPE_DROPDOWN,
  };
};

const setOrderTypeDropdown = (value: any) => {
  return {
    type: SET_ORDER_TYPE_DROPDOWN,
    payload: value,
  };
};
const getClientCodeDropdown = () => {
  return {
    type: GET_CLIENT_CODE_DROPDOWN,
  };
};

const setClientCodeDropdown = (value: any) => {
  return {
    type: SET_CLIENT_CODE_DROPDOWN,
    payload: value,
  };
};
const getReasonCodeDropdown = () => {
  return {
    type: GET_REASON_CODE_DROPDOWN,
  };
};

const setReasonCodeDropdown = (value: any) => {
  return {
    type: SET_REASON_CODE_DROPDOWN,
    payload: value,
  };
};
const getCapexDropdown = () => {
  return {
    type: GET_CAPEX_DROPDOWN,
  };
};

const setCapexDropdown = (value: any) => {
  return {
    type: SET_CAPEX_DROPDOWN,
    payload: value,
  };
};
const getAssignToDropdown = () => {
  return {
    type: GET_ASSIGNTO_DROPDOWN,
  };
};

const setAssignToDropdown = (value: any) => {
  return {
    type: SET_ASSIGNTO_DROPDOWN,
    payload: value,
  };
};

const setVendorDetails = (value: any) => {
  return {
    type: SET_VENDOR_DETAILS,
    payload: value,
  };
};

const getVendorDetails = (addressBookNo: any) => {
  return {
    type: GET_VENDOR_DETAILS,
    addressBookNo,
  };
};

const setPurchaseorderStepperData = (data: any) => {
  return {
    type: SET_PURACHSE_ORDER_STEPPER_DATA,
    payload: data,
  };
};

const setPurchaseorderStepperInfo = (data: any) => {
  return {
    type: SET_PURACHSE_ORDER_STEPPER_INFO,
    payload: data,
  };
};

const getChangeLogs = (data: any) => ({
  type: GET_CHANGE_LOGS,
  payload: data,
});

const setError = (data: any) => ({
  type: SET_ERROR,
  payload: data,
});

const setChangeLogs = (value: any) => {
  return {
    type: SET_CHANGE_LOGS,
    payload: value,
  };
};

const updateFleetStatusOrder = (value: any) => ({
  type: UPDATE_FLEET_STATUS_ORDER,
  payload: value,
});

const updateReasonCode = (value: any) => ({
  type: UPDATE_REASON_CODE,
  payload: value
})

const getEqClassCodeDropdown = () => {
  return {
    type: GET_PO_EQ_CLASS_CODE_DROPDOWN,
  };
};

const setEqClassCodeDropdown = (value: any) => {
  return {
    type: SET_PO_EQ_CLASS_CODE_DROPDOWN,
    payload: value,
  };
};

export {
  setOrderDetail,
  getFleetOrderDetail,
  setFleetOrderDetail,
  getPoolGridData,
  setPoolGridData,
  getPurchaseTypeDropdown,
  setPurchaseTypeDropdown,
  getRegisteredDropdown,
  setRegisteredDropdown,
  getOrderTypeDropdown,
  setOrderTypeDropdown,
  getClientCodeDropdown,
  setClientCodeDropdown,
  getReasonCodeDropdown,
  setReasonCodeDropdown,
  getAssignToDropdown,
  setAssignToDropdown,
  getCapexDropdown,
  setCapexDropdown,
  setVendorDetails,
  getVendorDetails,
  setPurchaseorderStepperData,
  setError,
  setChangeLogs,
  getChangeLogs,
  setPurchaseorderStepperInfo,
  updateFleetStatusOrder,
  updateReasonCode,
  getEqClassCodeDropdown,
  setEqClassCodeDropdown
};
